import addFile from './add';
import delFile from './del';
import getFileList from './getList';
import download from './download';
import getFileListByIds from './getListByIds';
export default {
  addFile,
  delFile,
  getFileList,
  download,
  getFileListByIds,
};


// WEBPACK FOOTER //
// ./src/api/files/index.ts